// extracted by mini-css-extract-plugin
module.exports = {"customTable":"styles_customTable__1_Ofg"};